export class DeviceLocationServiceConstants {
    public static readonly LOCATION_PLUGIN = 'Location'
    public static readonly ACTION_GET_DEVICE_LOCATION = 'getCurrentLocation'
}
